class MFRGeekCarousel {
    constructor( i, e, options ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            carousel: ".geek-carousel__carousel",
            nav: options.nav
        }

        this.options = options.flickityOptions;

        this.init();
    }

    init() {
        this.$carousel = this.$element.find( this.selectors.carousel );
        this.$nav = this.$element.find(this.selectors.nav);

        this.initCarousel();
        // $( window ).on( "resize", this.initCarousel.bind( this ) );
    }

    initCarousel() {
        if( this.$carousel.hasClass( "flickity-enabled" ) )
            this.$carousel.flickity( "destroy" );

        if( $( window ).width() <= 1023 ) {
            this.options["cellAlign"] = "center";
            this.options["pageDots"] = true;
            this.options["prevNextButtons"] = false;
        }
        else {
            this.options["cellAlign"] = "left";
            this.options["pageDots"] = false;
            this.options["prevNextButtons"] = true;
        }

        this.carousel = this.$carousel.flickity({
            ...this.options,
            on: {
                ready: () => {
                    this.initNav();
                }
            }
        })
    }

    initNav() {
        this.nav = this.$nav.flickity({
          ...this.options,
          prevNextButtons: false,
          draggable: false,
          asNavFor: this.$carousel.get(0)
        });
    }
}